import { InternalAxiosRequestConfig } from 'axios';
import { AccountInfo } from '@azure/msal-browser';
import { MsalInstance } from '../../MsalInstance';

interface RequestResolverProps {
  config: InternalAxiosRequestConfig;
  account: AccountInfo | null;
  instance: MsalInstance;
}

export const requestResolver = async ({
  config,
  account,
  instance,
}: RequestResolverProps): Promise<InternalAxiosRequestConfig> => {
  if (account) {
    try {
      const accessToken = await instance.getAccessToken(account);
      instance.setAccessTokenOnHeader(config, accessToken);
    } catch (e) {
      // eslint-disable-next-line no-empty -- we do not want to resolve any errors here because we only care about sending the request out
      // if we fail to get an access token here we will catch the 401 response in the responseResolver.
    }
  }

  return config;
};
